import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PresignService } from '../../../services/presign.service';

@Component({
  selector: 'app-upload-bill-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './upload-bill-modal.component.html',
})

export class UploadBillModalComponent {
  @Output() close = new EventEmitter<void>();
  @Output() filesUploaded = new EventEmitter<{ pdf: File; xml: File }>();

  pdfFile: File | null = null;
  xmlFile: File | null = null;
  isUploading = false;

  private readonly UUID_STORAGE_KEY = 'uuid_cfdi';

  constructor( private presignUrl: PresignService ){}

  get pdfName() {
    return this.pdfFile?.name ?? null;
  }

  get xmlName() {
    return this.xmlFile?.name ?? null;
  }

  private sanitizeFileName( file: File): File { 
    const cleanName = file.name.replace(/\s+/g, '_');
    if (cleanName === file.name) return file;
    return new File([file], cleanName, {type: file.type});
  }
  
  onPdfSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      let file = input.files[0];
      file = this.sanitizeFileName(file);
      this.pdfFile = file;
    }
  }

  onXmlSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      let file = input.files[0];
      file = this.sanitizeFileName(file);
      this.xmlFile = file;
    }
  }

  async uploadFiles() {
    if (!this.pdfFile || !this.xmlFile) {
      console.warn('Recuerde subir ambos archivos para continuar');
      return;
    }

    this.isUploading = true;

    try {
      const uuid = localStorage.getItem(this.UUID_STORAGE_KEY);
      if (!uuid) {
        console.error('No se encontró UUID');
        return;
      }
      
      const folder_name = uuid;
      const bucketName = 'FACT';

      const xmlSignedResponse = await this.presignUrl.getPresignedUrl(folder_name, this.xmlFile.name, bucketName);
      const pdfSignedResponse = await this.presignUrl.getPresignedUrl(folder_name, this.pdfFile.name, bucketName);

      await this.presignUrl.uploadFileToS3(xmlSignedResponse.uploadUrl, this.xmlFile);
      await this.presignUrl.uploadFileToS3(pdfSignedResponse.uploadUrl, this.pdfFile);

      const xmlStatusResponse = await this.presignUrl.uploadStatus(xmlSignedResponse.idProcesamiento);
      console.log(`Status xml:`, xmlStatusResponse);
      const pdfStatusResponse = await this.presignUrl.uploadStatus(pdfSignedResponse.idProcesamiento);
      console.log(`Status xml:`, pdfStatusResponse);

      this.filesUploaded.emit({ pdf: this.pdfFile, xml: this.xmlFile });
      this.close.emit();

    } catch (error) {
      console.error('Error al procesar los archivos', error);

    } finally {
      this.isUploading = false;
    }
  }
}